import React from "react";
import { useState, useEffect } from "react";
import "../CreateListPopup/CreateListPopup.scss";

export const CreateListPopup = (props) => {
  const [listName, setListName] = useState("");
  const userToken = localStorage.getItem("userToken");

  const createList = async () => {
    try {
      const url =
        "https://ciricgmbh-dokumentation.de/ciric-doku-api/a/cd/w/list-insert_w.php";

      const requestData = {
        list_name: listName,
      };

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Token: userToken,
        },
        body: JSON.stringify(requestData),
      });

      const responseData = await response.json();

      if (response.ok) {
        console.log("uspesno");
        props.setIsListCreated(true);
        props.onClose();
      } else {
        console.error("Došlo je do greške:", response.status);
      }
    } catch (error) {
      console.error("Došlo je do greške:", error);
    }
  };

  return (
    <div className="create-list">
      <div className="list-name">
        <div>Listen Name</div>
        <input value={listName} onChange={(e) => setListName(e.target.value)} />
      </div>
      <div className="buttons">
        <button onClick={createList}>Save</button>
        <button onClick={props.onClose}>Close</button>
      </div>
    </div>
  );
};
